app.service('SurgeryWaitlistAPI', [
	'$http', 
	'ENV', 
	'Session', 
	function($http, ENV, Session) {
		var service = {
			isProcessing: false,

			getAllSurgeryWaitlistsByPractice: function(nextPageIndex) {
				return $http({
					method: "POST",
					url: ENV.API + "/api/surgery-waitlist",
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: nextPageIndex
				});
			},
			getAllSurgeryWaitlistsByUser: (nextPageIndex) => {
				return $http({
					method: "POST",
					url: ENV.API + "/api/surgery-waitlist?getOnlyUsersSurgeryWaitlists=true",
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: nextPageIndex
				});
			},

			// One waitlist entry, in the same shape as an entry of the paginated list, so a single changed
			// entry can be refreshed without paging the whole practice's waitlist again.
			getSurgeryWaitlist: (patientId, surgeryWaitlistId) => {
				return $http({
					method: "GET",
					url: ENV.API + `/api/surgery-waitlist/${patientId}/${surgeryWaitlistId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
				});
			},

			// Adds a waitlist entry without a progress note.
			createSurgeryWaitlist: (patientId, surgeryWaitlist, addAutoTaskWaitlist) => {
				let url = ENV.API + `/api/surgery-waitlist/${patientId}`;
				if (addAutoTaskWaitlist !== undefined) {
					url += `?addAutoTaskWaitlist=${addAutoTaskWaitlist}`;
				}
				return $http({
					method: "POST",
					url: url,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: surgeryWaitlist
				});
			},

			updateSurgeryWaitlist: (patientId, sugeryWaitlistId, surgeryWaitlist) => {
				return  $http({
					method: "PUT",
					url: ENV.API + `/api/surgery-waitlist/${patientId}/${sugeryWaitlistId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: surgeryWaitlist
				})
			}
		}

		return service;
	}
])
